module.exports = __webpack_public_path__ + "assets/ovalbg-dd1d443d4a2afe4d6e4b0dc0000feca3.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/ovalbg.png
// module id = 58
// module chunks = 4